import { dynamicFailed } from "../hooks/useToast";
import { INotice } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";
import { checkNullDate } from "../exports/functions";

export const fetchNotices = async (): Promise<INotice[]> => {
  try {
    const response = await axiosClient.get<INotice[]>(`/notices`);

    return response.data
      .map((notice) => ({
        ...notice,
        endDate: checkNullDate(notice.endDate),
      }))
      .sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";
    dynamicFailed(message);
    return [];
  }
};
